import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Score = types.compose(
  BaseEntity,
  types.model('Score', {
    // scoreId: types.maybe(types.identifierNumber),
    feasible: types.maybe(types.boolean),
    hardScore: types.maybe(types.integer),
    initScore: types.maybe(types.integer),
    mediumScore: types.maybe(types.integer),
    softScore: types.maybe(types.integer),
    solutionInitialized: types.maybe(types.boolean),
  }),
);
